/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { object, string, bool } from 'prop-types';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import useStyles from './ProductItemStyles';
import { setProductPrefixPath } from '../../../../../helpers/determineInternationalizationPath';
import LazyImage from './LazyImage';
import ProductTitle from './ProductTitle';
import LazyLoadComponent from './LazyLoadComponent/LazyLoad';

const ZodiacProductItem = (props) => {
    const [loaded, setLoaded] = useState(false);
    const { item, presentationFamily, isZodiacProduct } = props;

    const styles = useStyles();
    const itemPath = isZodiacProduct ? item : item?.item;
    // image onLoad handler to update state to loaded
    const onLoad = () => {
        setLoaded(true);
    };

    const getProductImage = (getDOM) => {
        if (itemPath.productCategory && itemPath.productCategory === 'search') {
            return getDOM;
        }
        return <LazyLoadComponent lazyLoad={{ height: '200', once: true }}>{getDOM}</LazyLoadComponent>;
    };

    const classNames = `${loaded ? 'productImage' : 'imageContainer'}`;
    const defaultImg = `https:${itemPath.image?.path}/${itemPath.image?.name}x.jpg`;

    const colClasses = `slider productItem ${styles.productItemContainerWrapper} productItemContainer`;

    const getProductLink = () => setProductPrefixPath(itemPath.seo?.url);

    const srcSet = `https:${itemPath.image?.path}/${itemPath.image?.name}x.jpg`;
    const getDOM = (
        <>
            <div className={`${classNames} product-item-view`}>
                <LazyImage srcSet={srcSet} src={defaultImg} alt={itemPath.name} onLoad={onLoad} width="100%" height="100%" onClick={undefined} />
            </div>
        </>
    );

    const productLabel = itemPath && itemPath.name ? itemPath.name : '';

    return (
        <Grid className={`${colClasses} positionRelative col position-relative`} style={{ marginBottom: '1.5rem', padding: '0 15px' }}>
            <Link to={getProductLink()} passHref prefetch={false} tabIndex="-1" aria-label={itemPath ? productLabel + itemPath.product_name : 'Product'}>
                <div className="productWrapper">
                    {getProductImage(getDOM)}
                    <ProductTitle isZodiacProduct={isZodiacProduct} product={itemPath} presentationFamily={presentationFamily} />
                </div>
            </Link>
        </Grid>
    );
};

ZodiacProductItem.propTypes = {
    item: object.isRequired,
    presentationFamily: string.isRequired,
    isZodiacProduct: bool,
};

ZodiacProductItem.defaultProps = {
    isZodiacProduct: false,
};

export default ZodiacProductItem;
